import { HeadWrapper } from './HeadWrapper';
import { Box, Button, Heading, Paragraph } from '@zillow/constellation-10';
import { Link } from 'react-router-dom';

export const NotFoundPage = () => (
  <Box css={{ paddingBlock: '800', paddingInline: '1200', background: 'blue.300' }}>
    <HeadWrapper title="Page not found" />
    <Heading level={1} textStyle="heading-xl" css={{ color: 'text.accent.blue.hero' }}>
      Uh oh,
      <br />
      something broke.
    </Heading>
    <Paragraph css={{ textStyle: 'heading-xs', marginBottom: '600', color: 'text.accent.blue.hero' }}>
      Error 404 - page not found
    </Paragraph>
    <Link to="/rental-manager">
      <Button css={{ marginTop: '600' }} tone="brand" emphasis="filled">
        Return to Zillow Rental Manager
      </Button>
    </Link>
  </Box>
);
